/* card-reveal — premium staggered entrance for card grids (GSAP), matching the
   quality of the heading / eyebrow reveals.

   When a [data-fade-stagger] container scrolls into view its cards rise + fade
   in, one clearly after the next (48px, 0.1s stagger, strong ease).

     data-fade-stagger          → card rises + fades + gently scales (0.96 → 1)
     data-fade-stagger="image"  → card rises + fades, and the IMAGE inside each
                                  card scales from 1.2 → 1 (a zoom-out settle,
                                  clipped by the card frame). The card itself is
                                  not scaled.

   Flash-free: cards are hidden from the very first paint via CSS
   (`.js [data-fade-stagger] > *`); the script animates them in, or restores
   them when it bails. Inert under prefers-reduced-motion, the Shopify theme
   editor, or without GSAP / IntersectionObserver. */
(function () {
  const groups = document.querySelectorAll('[data-fade-stagger]');
  if (!groups.length) return;

  const cardsOf = (g) => Array.prototype.slice.call(g.children);

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = window.Shopify && window.Shopify.designMode;
  const ready = window.gsap && 'IntersectionObserver' in window;

  if (reduce || inEditor || !ready) {
    groups.forEach((g) => cardsOf(g).forEach((c) => { c.style.opacity = '1'; }));
    return;
  }

  const gsap = window.gsap;

  groups.forEach((group) => {
    const imageMode = group.getAttribute('data-fade-stagger') === 'image';

    // Puts the group's current cards in their hidden start state. Runs again on
    // reveal, because a section can swap its cards after load (the socials live
    // Instagram feed does).
    const prepare = () => {
      const cards = cardsOf(group);

      // The image inside each card (image mode only). Disable its CSS transition
      // while GSAP drives the transform, then hand it back so :hover still works.
      const imgs = imageMode
        ? cards.map((c) => c.querySelector('img')).filter(Boolean)
        : [];

      gsap.set(cards, imageMode
        ? { autoAlpha: 0, y: 48, willChange: 'transform, opacity' }
        : { autoAlpha: 0, y: 48, scale: 0.98, willChange: 'transform, opacity' });
      if (imgs.length) {
        imgs.forEach((img) => { img.style.transition = 'none'; });
        gsap.set(imgs, { scale: 1.08, transformOrigin: 'center center' });
      }
      return { cards, imgs };
    };

    prepare();
    // Tells code that swaps cards in later that the entrance is still to come.
    group.setAttribute('data-reveal-pending', '');

    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      group.removeAttribute('data-reveal-pending');
      const { cards, imgs } = prepare();

      gsap.to(cards, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.7,
        stagger: 0.1,
        ease: 'power3.out',
        // Hand transform back so card :hover works, and drop the will-change
        // layer hint now the entrance is done.
        clearProps: 'transform,willChange',
      });

      if (imgs.length) {
        gsap.to(imgs, {
          scale: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power3.out',
          clearProps: 'transform',
          onComplete: () => imgs.forEach((img) => { img.style.transition = ''; }),
        });
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -12% 0px' });

    io.observe(group);
  });
})();
